import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddTouchesTypeComponent } from '../addtouchestype/addtouchestype.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { DatePipe } from '@angular/common';
import { AddToucheStatusTypeComponent } from '../addtouchestatustype/addtouchestatustype.component';
import { AddIncomeComponent } from '../addIncome/addIncome.component';
import { AddAssetExpenseComponent } from '../addAssetExpense/addAssetExpense.component';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { Observable } from 'rxjs';
import { LoaderService } from '../../shared/loader/loader.service';


@Component({
  selector: 'app-medicareAssessment',
  templateUrl: './medicareAssessment.component.html',
  styleUrls: ['./medicareAssessment.component.scss']
})

export class MedicareAssessmentComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  selectedCoreName: string = "";
  episodeID: number = 0;
  coreID: number = 0;
  accountingList: any = [] = [];
  assetsList: any = [] = [];
  expensesList: any = [] = [];
  incomesList: any = [] = [];

  assetsListFilter: any = [] = [];
  expensesListFilter: any = [] = [];
  incomesListFilter: any = [] = [];

  constructor(private dialog: MatDialog, private dialog1: MatDialog, private datePipe: DatePipe, public dialogRef: MatDialogRef<MedicareAssessmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService, private loaderService: LoaderService,) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }

  }

  ngOnInit(): void {
    this.selectedCoreName = this.data.selectedCoreName;
    this.episodeID = this.data.episodeID;
    this.coreID = this.data.coreID;
    this.getAccountingforPDPMCore();
  }

  getAccountingforPDPMCore() {
    var ReqModel = {
      coreID: this.coreID,
      episodeID: this.episodeID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.coreService.getAccountingforPDPMCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.accountingList = this.responseHolder.data;
          this.assetsList = this.accountingList.assets;
          this.expensesList = this.accountingList.expenses;
          this.incomesList = this.accountingList.incomes;

          // for Filter
          this.assetsListFilter = this.accountingList.assets;
          this.expensesListFilter = this.accountingList.expenses;
          this.incomesListFilter = this.accountingList.incomes;


          //== For Combined ===// 
          if (this.selectedtypeforActive == 0) {
            this.assetsList = this.accountingList.assets;
            this.expensesList = this.accountingList.expenses;
            this.incomesList = this.accountingList.incomes;
          }
          //== For Resident ===// 
          if (this.selectedtypeforActive == 1) {
            if (this.assetsListFilter.length > 0) {
              this.assetsList = this.assetsListFilter.filter((x:any) => x.assetBy == 0);
            }
            if (this.incomesListFilter.length > 0) {
              this.incomesList = this.incomesListFilter.filter((x:any) => x.incomeBy == 0);
            }
            if (this.expensesListFilter.length > 0) {
              this.expensesList = this.expensesListFilter.filter((x:any) => x.expenseBy == 0);
            }
          }
          //== For Spouse ===// 
          if (this.selectedtypeforActive == 2) {
            if (this.assetsListFilter.length > 0) {
              this.assetsList = this.assetsListFilter.filter((x:any) => x.assetBy == 1);
            }
            if (this.incomesListFilter.length > 0) {
              this.incomesList = this.incomesListFilter.filter((x:any) => x.incomeBy == 1);
            }
            if (this.expensesListFilter.length > 0) {
              this.expensesList = this.expensesListFilter.filter((x:any) => x.expenseBy == 1);
            }
          }

          this.allowableDeduction=this.responseHolder.data.allowableDeduction;
          this.countableAsset=this.responseHolder.data.countableAsset;
          this.estPatientLiability=this.responseHolder.data.estPatientLiability;
          this.exemptAsset=this.responseHolder.data.exemptAsset;
          this.grossIncome=this.responseHolder.data.grossIncome;
          this.netIncome=this.responseHolder.data.netIncome;
          this.pnAllowance=this.responseHolder.data.pnAllowance;
          this.resourceLimit=this.responseHolder.data.resourceLimit;
          this.spenddownNeeded=this.responseHolder.data.spenddownNeeded;

        }
        else {
          this.accountingList = [];
          this.assetsList = [];
          this.expensesList = [];
          this.incomesList = [];
          this.loaderService.hide();
        }
      }
      else {
        this.accountingList = [];
        this.assetsList = [];
        this.expensesList = [];
        this.incomesList = [];
        this.loaderService.hide();
      }
    });

  }

  closeDialog() {
    this.dialog.closeAll();
  }

  //======Add/Update/Delete Income ===========//

  addIncome() {
    // return;    
    const dialogRef = this.dialog.open(AddIncomeComponent, {
      data: {
        incomeID: 0,
        selectedCoreName: this.selectedCoreName,
        episodeID: this.episodeID,
        coreID: this.coreID,
        type: this.type
      },
     // width: '35vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getAccountingforPDPMCore();
      }
    });
  }

  editIncome(editIncome: any) {
    const dialogRef = this.dialog.open(AddIncomeComponent, {
      data: {
        incomeID: editIncome.incomeID,
        selectedCoreName: this.selectedCoreName,
        episodeID: this.episodeID,
        coreID: this.coreID,
        incomeData: editIncome,
        type: this.type
      },
     // width: '35vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getAccountingforPDPMCore();
      }
    });
  }

  deleteIncome(editIncome: any) {
    const message = `Are you sure you want to delete this record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            incomeID: editIncome.incomeID,
            userID: this.currentUser.UID,
            databaseID: Number(this.databaseId),
            organizationID: Number(this.organizationId),
            officeID: this.myOfficeID,
            officeIDList: this.OfficeIDList
          }
          this.loaderService.show();
          this.coreService.removeIncomeforPDPMCore(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.getAccountingforPDPMCore();
                this.loaderService.hide();
                this.toastr.success('Record deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
              }
            } else {
              this.loaderService.hide();
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  //======Add/Update/Delete Asset/Expense ===========//

  addAsset(from: any) {
    //return;   
    const dialogRef = this.dialog.open(AddAssetExpenseComponent, {
      data: {
        assetIDexpenseID: 0,
        addedFor: from,
        selectedCoreName: this.selectedCoreName,
        episodeID: this.episodeID,
        coreID: this.coreID,
        type: this.type
      },
   //   width: '35vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getAccountingforPDPMCore();
      }
    });
  }

  editAsset(from: any, asset: any) {
    //return; 
    var assetIDexpenseID: number = 0;
    if (from == "Asset") {
      assetIDexpenseID = asset.assetID;
    }
    if (from == "Expense") {
      assetIDexpenseID = asset.expenseID;
    }
    const dialogRef = this.dialog.open(AddAssetExpenseComponent, {
      data: {
        assetIDexpenseID: assetIDexpenseID,
        addedFor: from,
        selectedCoreName: this.selectedCoreName,
        episodeID: this.episodeID,
        coreID: this.coreID,
        assetData: asset,
        type: this.type
      },
    //  width: '35vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getAccountingforPDPMCore();
      }
    });
  }

  deleteAsset(asset: any) {
    const message = `Are you sure you want to delete this record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            assetID: asset.assetID,
            userID: this.currentUser.UID,
            databaseID: Number(this.databaseId),
            organizationID: Number(this.organizationId),
            officeID: this.myOfficeID,
            officeIDList: this.OfficeIDList
          }
          this.loaderService.show();
          this.coreService.removeAssetforPDPMCore(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.getAccountingforPDPMCore();
                this.loaderService.hide();
                this.toastr.success('Record deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
              }
            } else {
              this.loaderService.hide();
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  deleteExpense(expenses: any) {
    const message = `Are you sure you want to delete this record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            expenseID: expenses.expenseID,
            userID: this.currentUser.UID,
            databaseID: Number(this.databaseId),
            organizationID: Number(this.organizationId),
            officeID: this.myOfficeID,
            officeIDList: this.OfficeIDList
          }
          this.loaderService.show();
          this.coreService.removeExpenseforPDPMCore(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.getAccountingforPDPMCore();
                this.loaderService.hide();
                this.toastr.success('Record deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
              }
            } else {
              this.loaderService.hide();
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  type: number = 0;
  selectedtypeforActive: number = 0;

  selectType(type) {
    if (type == 0) {
      this.selectedtypeforActive = 0;
    }
    if (type == 1) {
      this.selectedtypeforActive = 1;
    }
    if (type == 2) {
      this.selectedtypeforActive = 2;
    }
    if (type == 0 || type == 1) {
      type = 0;
    }
    if (type == 2) {
      type = 1;
    }
    this.type = Number(type);

    //== For Combined ===// 
    if (this.selectedtypeforActive == 0) {
      this.assetsList = this.accountingList.assets;
      this.expensesList = this.accountingList.expenses;
      this.incomesList = this.accountingList.incomes;
    }
    //== For Resident ===// 
    if (this.selectedtypeforActive == 1) {
      if (this.assetsListFilter.length > 0) {
        this.assetsList = this.assetsListFilter.filter((x:any) => x.assetBy == 0);
      }
      if (this.incomesListFilter.length > 0) {
        this.incomesList = this.incomesListFilter.filter((x:any) => x.incomeBy == 0);
      }
      if (this.expensesListFilter.length > 0) {
        this.expensesList = this.expensesListFilter.filter((x:any) => x.expenseBy == 0);
      }
    }
    //== For Spouse ===// 
    if (this.selectedtypeforActive == 2) {
      if (this.assetsListFilter.length > 0) {
        this.assetsList = this.assetsListFilter.filter((x:any) => x.assetBy == 1);
      }
      if (this.incomesListFilter.length > 0) {
        this.incomesList = this.incomesListFilter.filter((x:any) => x.incomeBy == 1);
      }
      if (this.expensesListFilter.length > 0) {
        this.expensesList = this.expensesListFilter.filter((x:any) => x.expenseBy == 1);
      }
    }
  }

   numberOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow: Backspace, Tab, Delete, Left, Right arrows
    if ([8, 9, 46, 37, 39].includes(charCode)) {
      return true;
    }

    // Allow numbers (0-9)
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }

    // Allow decimal point (.)
    if (charCode === 46) {
      // Prevent more than one decimal point
      const inputValue = (event.target as HTMLInputElement).value;
      if (inputValue.includes('.')) {
        return false;
      }
      return true;
    }

    return false;
  }

  pnAllowance:any;
  resourceLimit:any;
  grossIncome:any;
  netIncome:any;
  spenddownNeeded:any;
  countableAsset:any;
  allowableDeduction:any;
  estPatientLiability:any;
  exemptAsset:any;

  addPNAadResourceLimit() {
    var ReqModel = {
      coreID: this.coreID,
      episodeID: this.episodeID,
      pnAllownce:Number(this.pnAllowance),
      resourceLimit:Number(this.resourceLimit),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.coreService.addPNAadResourceLimit(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
           this.getAccountingforPDPMCore();
        }
        else {         
          this.loaderService.hide();
        }
      }
      else {        
        this.loaderService.hide();
      }
    });

  }

}
